var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 17.5V5.83333C6.66699 5.05836 6.66699 4.67087 6.75218 4.35295C6.98335 3.49022 7.65721 2.81635 8.51995 2.58519C8.83786 2.5 9.22535 2.5 10.0003 2.5C10.7753 2.5 11.1628 2.5 11.4807 2.58519C12.3434 2.81635 13.0173 3.49022 13.2485 4.35295C13.3337 4.67087 13.3337 5.05836 13.3337 5.83333V17.5M4.33366 17.5H15.667C16.6004 17.5 17.0671 17.5 17.4236 17.3183C17.7372 17.1586 17.9922 16.9036 18.152 16.59C18.3337 16.2335 18.3337 15.7668 18.3337 14.8333V8.5C18.3337 7.56658 18.3337 7.09987 18.152 6.74335C17.9922 6.42975 17.7372 6.17478 17.4236 6.01499C17.0671 5.83333 16.6004 5.83333 15.667 5.83333H4.33366C3.40024 5.83333 2.93353 5.83333 2.57701 6.01499C2.2634 6.17478 2.00844 6.42975 1.84865 6.74335C1.66699 7.09987 1.66699 7.56658 1.66699 8.5V14.8333C1.66699 15.7668 1.66699 16.2335 1.84865 16.59C2.00844 16.9036 2.2634 17.1586 2.57701 17.3183C2.93353 17.5 3.40024 17.5 4.33366 17.5Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.1149de5a7fa9d9dab11417bfbb256ee7.svg";
export { ForwardRef as ReactComponent };